import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type React from "react";
import type { ParticipationStatus } from "@/types/event-attendance";

interface ParticipationToggleProps {
	value: ParticipationStatus | undefined;
	disabled?: boolean;
	onChange: (next: ParticipationStatus | null) => void;
}

export const ParticipationToggle: React.FC<ParticipationToggleProps> = ({
	value,
	onChange,
	disabled,
}) => (
	<ToggleButtonGroup
		exclusive
		size="small"
		value={value || null}
		onChange={(_, newValue) => {
			if (newValue === null) return;
			onChange(newValue as ParticipationStatus);
		}}
		disabled={disabled}
		aria-label="Teilnahmestatus"
	>
		<ToggleButton
			color="info"
			value="yes"
			sx={{
				"&.Mui-selected": {
					bgcolor: (theme) => alpha(theme.palette.info.main, 0.8),
					color: (theme) => theme.palette.info.contrastText,
					"&:hover": {
						bgcolor: (theme) => alpha(theme.palette.info.main, 0.95),
					},
				},
			}}
			aria-label="Teilgenommen"
			title="Teilgenommen"
		>
			<CheckIcon sx={{ fontSize: "1.5em" }} />
		</ToggleButton>
		<ToggleButton
			color="error"
			value="no"
			sx={{
				"&.Mui-selected": {
					bgcolor: (theme) => alpha(theme.palette.error.main, 0.8),
					color: (theme) => theme.palette.error.contrastText,
					"&:hover": {
						bgcolor: (theme) => alpha(theme.palette.error.main, 0.95),
					},
				},
			}}
			aria-label="Nicht teilgenommen"
			title="Nicht teilgenommen"
		>
			<CloseIcon sx={{ fontSize: "1.5em" }} />
		</ToggleButton>
		<ToggleButton
			color="warning"
			value="goalie"
			sx={{
				"&.Mui-selected": {
					bgcolor: (theme) => alpha(theme.palette.warning.main, 0.8),
					color: (theme) => theme.palette.warning.contrastText,
					"&:hover": {
						bgcolor: (theme) => alpha(theme.palette.warning.main, 0.95),
					},
				},
			}}
			aria-label="Torwart"
			title="Torwart"
		>
			<EmojiEventsIcon sx={{ fontSize: "1.5em" }} />
		</ToggleButton>
	</ToggleButtonGroup>
);
